import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeMount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import TicketCategoryForm from '@/modules/ticket_category/components/TicketCategoryForm.vue';
import { TicketCategory, useTicketCategory } from '@/modules/ticket_category/TicketCategory';
import { handleLoadError } from '@/core/common';


export default /*@__PURE__*/_defineComponent({
  __name: 'TicketCategoryEdit',
  setup(__props) {

const { $gettext } = useGettext();
const route = useRoute();
const router = useRouter();
const ticketCategory = ref<TicketCategory | null>(null);

const load = async () => {
	try {
		const response = await useTicketCategory().get(route.params.id as string);
		if (response) {
			ticketCategory.value = response;
		}
	} catch (e) {
		handleLoadError(e as Error, 'ticket_category.index');
	}
};

watch(route, () => {
	if (route.params.id) {
		load();
	}
});
onBeforeMount(load);

const saved = (u) => {
	ticketCategory.value = u;
	Flash.success($gettext('Kategorin har sparats.'));
};

const cancel = () => {
	router.push({ name: 'ticket_category.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TicketCategoryForm, {
    "page-title": _unref($gettext)('Redigera kategori'),
    "ticket-category": ticketCategory.value,
    onSaved: saved,
    onCancel: cancel
  }, null, 8, ["page-title", "ticket-category"]))
}
}

})